import { Divider, Link, Typography } from '@material-ui/core';

import { InfoCard } from '@backstage/core-components';
import { ScoreRuleLabels } from '@internal/ui-common';
import { scoreRules } from '../utils/scoreRules';
import { useRef } from 'react';

export const VulnerabilitiesGuideCard = () => {
  const guideLink = useRef({
    text: 'How to fix vulnerabilities in Infinity Portal.',
    link: 'https://zf-scalar.atlassian.net/wiki/spaces/INFINITY/pages/4069884273/How+to+fix+vulnerabilities+showed+in+Infinity+Portal',
  });
  return (
    <InfoCard variant="gridItem" title="Recommended Action">
      <Typography component="span" variant="body1" color="textSecondary">
        This scorecard, updated every 24 hours, lists vulnerabilities detected
        in your containers running on our Kubernetes platform. Vulnerabilities
        can be exploited by attackers, potentially compromising SCALAR. Each
        entry represents a workload (aka deployment), and expanding the view
        reveals the vulnerable package and associated CVEs for details. Fixing
        vulnerabilities usually involves updating the affected package to its
        latest version. Ensure Renovate is enabled on all your repositories to
        help keep your applications secure and up-to-date. For detailed
        guidance, visit{' '}
        <Link href={guideLink.current.link} underline="always">
          {guideLink.current.text}
        </Link>
        <p />
        <Divider />
        <ScoreRuleLabels scoreRules={scoreRules} />
        <p />* Only vulnerabilities with available CVE fixes are considered in
        the call to action.
      </Typography>
    </InfoCard>
  );
};
